import { memo } from 'react';

import ChevronSelectorIconSVG from '@/assets/chevron-selector-vertical-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

export type ChevronSelectorIconProps = Omit<IconProps, 'SVGComponent'> & {};

const IChevronSelectorIcon = ({ ...rest }: ChevronSelectorIconProps) => {
  return <Icon SVGComponent={ChevronSelectorIconSVG} {...rest} />;
};

export const ChevronSelectorIcon = memo(IChevronSelectorIcon) as typeof IChevronSelectorIcon;
